"use client";
import { jsx } from "react/jsx-runtime";
import { ZIPCODE_QUERY_PARAM } from "../../../utils/constants.js";
import { Suspense } from "react";
import { Popover, Spinner } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
import "../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../Chrome/BrowseContext/hook.js";
import { FlyoutComposer } from "../../Scaffolding/FlyoutScaffolding/index.js";
const SameDay = ({
  entry,
  locale,
  analyticsTitle
}) => {
  const { deliveryLocation } = useBrowseContext();
  if (!entry) return null;
  const { title } = entry.link;
  const url = entry.link.url.replace(
    ZIPCODE_QUERY_PARAM,
    ZIPCODE_QUERY_PARAM + deliveryLocation.zipCode
  );
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [title]
        },
        doNotTrack: entry.disable_third_party_tracking,
        title: analyticsTitle || entry.link.title
      },
      children: /* @__PURE__ */ jsx(
        Popover,
        {
          buttonText: title,
          hasArrow: true,
          hasChevronDownIcon: false,
          href: url,
          position: "bottom",
          setFocus: "First Actionable",
          sxButton: { padding: 0 },
          children: /* @__PURE__ */ jsx(
            Suspense,
            {
              fallback: /* @__PURE__ */ jsx(Spinner, { label: "blue-category", size: "medium" }),
              children: /* @__PURE__ */ jsx(
                FlyoutComposer,
                {
                  entry: entry.flyout_scaffolding,
                  locale,
                  width: entry.flyout_width || "normal"
                }
              )
            }
          )
        }
      )
    }
  );
};
export {
  SameDay
};
